import styled from 'styled-components';
import { select } from '@panel/commons/core/themev2';
import { getColor } from '@panel/commons/core/themev3';
import GenerateIcon from '../../../../assets/icons/generateAI.svg';
import UndoIcon from '../../../../assets/icons/undo.svg';
import starsIcon from '../../../../assets/icons/IconStarsIA.svg';

const Container = styled.div`
  max-width: 572px;
  gap: 24px;
  display: flex;
  flex-direction: column;
`;
const InputContainer = styled.div`
  max-width: 572px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;

  .input-labels {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 4px;
  }
`;

const Label = styled.label`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px;
`;

const AssistTextHint = styled.div`
  flex: 3;
`;

const Counter = styled.div`
  color: ${({ error }) => (!error || error === 'maxLength' ? select('midDarkGrayAux') : select('errorRed'))};
  text-align: right;
  width: 100%;
  font-family: Hind;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  flex: 1;
`;

const InputTitle = styled.textarea`
  display: block;
  min-height: 48px;
  padding: 12px 16px;
  border-radius: 8px;
  resize: none;
  overflow: hidden;
  box-sizing: border-box;
  font-family: inherit;
  font-size: 14px;
  white-space: break-spaces;
  overflow: hidden;
  &:focus {
    outline: none;
    border: 1px solid
      ${({ error }) =>
        !error ? getColor('primary') : error === 'maxLength' ? select('darkestYellow') : select('errorRed')};
  }
  border: 1px solid
    ${({ error }) =>
      !error ? select('midDarkGrayAux') : error === 'maxLength' ? select('darkestYellow') : select('errorRed')};
`;

const TextArea = styled.textarea`
  display: flex;
  min-height: 112px;
  max-height: ${({ isDesktop }) => (isDesktop ? '664px' : '304px')};
  padding: 8px 16px;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid
    ${({ error }) =>
      !error ? select('midDarkGrayAux') : error === 'maxLength' ? select('darkestYellow') : select('errorRed')};
  resize: none;
  overflow-y: auto;
  box-sizing: border-box;

  /* Estilos del scroll */
  ::-webkit-scrollbar {
    width: 4px;
    height: 20px;
  }
  ::-webkit-scrollbar-track {
    background: transparent;
    width: 8px;
    border-radius: 3px;
    padding: 2px;
  }
  ::-webkit-scrollbar-thumb {
    background: ${select('midDarkGrayAux')};
    border-radius: 3px;
    background-clip: content-box;
  }

  &:focus {
    outline: none;
    border: 1px solid
      ${({ error }) =>
        !error ? getColor('primary') : error === 'maxLength' ? select('darkestYellow') : select('errorRed')};
  }
`;

const InputCode = styled.textarea`
  max-width: 100%;
  display: block;
  min-height: 48px;
  padding: 12px 8px;
  border-radius: 8px;
  border: 1px solid ${({ error }) => (!error ? select('midDarkGrayAux') : select('errorRed'))};
  resize: none;
  overflow: hidden;
  box-sizing: border-box;
  font-family: inherit;
  font-size: 14px;
  line-height: 24px;
  white-space: ${({ isMobile }) => (isMobile ? 'break-spaces' : 'nowrap')};
  overflow-x: hidden;
  &:focus {
    outline: none;
    border: 1px solid ${({ error }) => (!error ? getColor('primary') : select('errorRed'))};
  }
`;

const InputFooterContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 4px;
`;

const ErrorMessage = styled.span`
  color: ${({ typeError, internalCodeError }) =>
    typeError === 'maxLength' && !internalCodeError ? select('black') : select('errorRed')};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  white-space: break-spaces;
`;

const ButtonAI = styled.button`
  height: 32px;
  text-align: center;
  font-family: Hind;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 130%;
  padding: 0px 12px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 4px;
  :hover {
    background-color: ${({ device }) => select(device === 'mobile' ? 'transparent' : 'neutralDarkGray')};
    cursor: pointer;
  }
`;

const ConfirmedTextAI = styled.span`
  font-family: Hind;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  display: flex;
  align-items: center;
  gap: 4px;
`;

const Icons = {
  generate: GenerateIcon,
  undo: UndoIcon,
  stars: starsIcon
};

const IconAI = styled.img`
  height: ${({ height }) => height || '20px'};
  width: ${({ width }) => width || '20px'};
`;

export {
  Container,
  InputContainer,
  Label,
  Counter,
  InputTitle,
  TextArea,
  InputCode,
  ErrorMessage,
  InputFooterContainer,
  ButtonAI,
  ConfirmedTextAI,
  IconAI,
  Icons,
  AssistTextHint
};
